import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
import di from "../di/index";
import { ECurrentLoginComponent } from "@domains/salesFeatures/Login/entities/iLogin";
import { ERole } from "../Login";
var ForgotIDPasswordButton = function (props) {
    var _a = props.showForgotPasswordBtn, showForgotPasswordBtn = _a === void 0 ? true : _a, _b = props.showLoginIdBtn, showLoginIdBtn = _b === void 0 ? true : _b;
    return (React.createElement("div", { className: "d-flex align-items-center forgot-actions-btn-container" },
        showLoginIdBtn && (React.createElement(EdButton, { value: (props === null || props === void 0 ? void 0 : props.tabType) === ERole.Partner ? "Forgot login ID?" : "Forgot Password?", btnTyp: "midnight-blue-underline", className: "forgot-login forgot-login-id-btn", onClick: function () {
                if ((props === null || props === void 0 ? void 0 : props.tabType) === ERole.Partner) {
                    di.login.changeCurrentLoginComponent({
                        currentComponent: ECurrentLoginComponent.FORGOT_LOGIN_ID,
                    });
                }
                else
                    window.location.href = URLConfig.config.forgotLoginIdURL;
            } })),
        showForgotPasswordBtn && (React.createElement(EdButton, { value: "Forgot Password?", btnTyp: "midnight-blue-underline", className: "forgot-login forgot-password-btn", onClick: function () {
                di.login.changeCurrentLoginComponent({
                    currentComponent: ECurrentLoginComponent.FORGOT_PASSWORD,
                });
            } }))));
};
export default ForgotIDPasswordButton;
